import { useState, useEffect, ChangeEvent, useCallback, useRef } from "react";
import StitchList, { StitchOrientation } from "./Components/StitchList";
import "./App.css";
import ImageEditor from "./Components/ImageEditor";
import { Image } from "./Lib/Image";

const IMAGE_TIMEOUT = 500;

function App() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<DOMException>();
  const [bitmap, setBitmap] = useState<ImageBitmap>();
  const [image, setImage] = useState<Image>();
  const timerRef = useRef<number>();
  const [orientation, setOrientation] = useState<StitchOrientation>(
    () =>
      (localStorage.getItem("orientation") as StitchOrientation) ||
      "bottom-right"
  );

  useEffect(
    () => localStorage.setItem("orientation", orientation),
    [orientation]
  );

  // useEffect(() => {
  //   let controller = new AbortController();
  //   setLoading(true);
  //   fetch("Pac-man.png", { signal: controller.signal })
  //     .then((response) => response.blob())
  //     .then((blob) => createImageBitmap(blob))
  //     .then(setBitmap)
  //     .catch((error) => setError(error))
  //     .finally(() => setLoading(false));

  //   return () => controller.abort();
  // }, [setBitmap]);

  const onLoad = useCallback(
    (ev: ChangeEvent<HTMLInputElement>) => {
      setError(undefined);
      const files = ev.target.files;
      if (files?.length === 1) {
        const file = files[0];
        setLoading(true);
        createImageBitmap(file)
          .then(setBitmap)
          .catch((error: DOMException) => setError(error))
          .finally(() => setLoading(false));
      }
    },
    [setBitmap]
  );

  const changeImage = useCallback((image: Image) => {
    setImage(undefined);
    if (timerRef.current !== undefined) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => {
      setImage(image);
      timerRef.current = undefined;
    }, IMAGE_TIMEOUT);
  }, []);

  return (
    <div className="App">
      <h1>Crochety</h1>
      {loading && "Loading..."}
      {error && error.name !== "AbortError" && <h1>{error.message}</h1>}
      {bitmap && <ImageEditor bitmap={bitmap} onChange={changeImage} />}
      <div>
        <label htmlFor="file">Load:</label>
        <input id="file" type="file" onChange={onLoad} disabled={loading} />
      </div>
      <div>
        <label htmlFor="orientation">Start at: </label>
        <select
          id="orientation"
          value={orientation}
          onChange={(ev) =>
            setOrientation(ev.target.value as StitchOrientation)
          }
        >
          <option value="top-left">Top Left</option>
          <option value="top-right">Top Right</option>
          <option value="bottom-left">Bottom Left</option>
          <option value="bottom-right">Bottom Right</option>
        </select>
      </div>
      <div>
        {image && (
          <>
            <h2>Stitches</h2>
            <StitchList image={image} orientation={orientation} />
          </>
        )}
      </div>
    </div>
  );
}

export default App;
